export default __webpack_public_path__ + "static/table-roi-54453e6fa74eb91ff84a752fbf8c9b65.svg";